<template>
  <div class="MaterialCenter">
    <AppHeader>素材中心</AppHeader>
    <AppBox class="appBox">
      <div>
        <el-button
            size="small"
            :class="curTab === 1 ? 'tabSelect' : 'tabUnSelect'"
            @click="selectTag(1)"
        >图片
        </el-button
        >
        <el-button
            size="small"
            :class="curTab === 2 ? 'tabSelect' : 'tabUnSelect'"
            @click="selectTag(2)"
        >音频
        </el-button
        >
        <el-button
            size="small"
            :class="curTab === 3 ? 'tabSelect' : 'tabUnSelect'"
            @click="selectTag(3)"
        >视频
        </el-button
        >
        <el-button
            size="small"
            :class="curTab === 4 ? 'tabSelect' : 'tabUnSelect'"
            @click="selectTag(4)"
        >知识
        </el-button
        >

        <el-button
            size="small"
            :class="curTab === 5 ? 'tabSelect' : 'tabUnSelect'"
            @click="selectTag(5)"
        >咨询
        </el-button
        >

        <el-button
            v-show="permissionCode.has('lesson:material:manager')"
            size="small"
            class="addButton"
            type="primary"
            @click="handleAdd"
        >新增
        </el-button
        >
        <el-button
            size="small"
            class="findButton"
            type="primary"
            @click="search"
        >查找
        </el-button
        >
        <el-input
            class="findInput"
            size="small"
            v-model="keyword"
            placeholder="名称"
        ></el-input>
      </div>
      <div class="materialContent">
        <div v-for="item in dataSource" :key="item.id" class="materialCard">

          <el-popover v-if="curTab === 1"
                      placement="top"
                      width="200"
                      trigger="hover"
                      :content="item.name">
            <el-image slot="reference" class="materialCardImage"
                      :lazy="true"
                      object-fit="scale-down"
                      :preview-src-list=[item.url]
                      :src="item.url"/>
          </el-popover>

          <div v-if="curTab === 2" class="materialCardAudio">
            <el-card>{{ item.name }}</el-card>
            <audio style="width: 100%;padding: 0 10px;margin: 15px 0;"
                   :src="item.url"
                   :loop="false"
                   controls
                   preload="auto"
                   controlsList="nodownload noplaybackrate"

            ></audio>
          </div>


          <el-popover v-if="curTab === 3"
                      placement="top"
                      width="200"
                      trigger="hover"
                      :content="item.name">
            <y-j-video class="materialCardVideo" slot="reference" :src="item.url"></y-j-video>
          </el-popover>


          <div v-if="curTab === 4 || curTab === 5" class="materialCardText">
            <div class="materialCardTextTitle">{{ item.title }}</div>
            <div class="materialCardTextContent">{{ item.content }}</div>
          </div>

          <div v-if="currentTenantId===item.tenantId" class="cardOpRow"
               v-show="permissionCode.has('lesson:material:manager')">
            <i class="el-icon-edit editBtn" @click="handleEdit(item)"></i>
            <i class="el-icon-delete deleteBtn" @click="handleDelete(item)"></i>
          </div>
        </div>
      </div>
      <div class="pagenation">
        <AppPagination
            v-if="hasPagination && !loading"
            :pageSize="pagination.pageSize"
            :total="pagination.total"
            :currentPage="pagination.currentPage"
            :pageSizesArr="[15]"
            :layout="'prev, pager, next'"
            @pageChange="pageChange"
        />
      </div>
    </AppBox>
    <MaterialUploadModal
        :materialInfo="materialInfo"
        :materialType="materialType"
        @refreshMaterialList="refreshMaterialList"
    ></MaterialUploadModal>
  </div>
</template>

<script>
import AppBox from "@/components/ui/AppBox/index.vue";
import AppHeader from "@/components/ui/AppHeader/index.vue";
import AppPagination from "@/components/ui/AppPagination/AppPagination";
import MaterialUploadModal from "./components/MaterialUploadModal.vue";
import {mapActions, mapMutations, mapState} from "vuex";
import sortPage from "@/pages/MyOutLine/SortPage.vue";
import VideoPage from "@/pages/MyOutLine/VideoPage.vue";
import YJVideo from "@/components/video/index.vue";

export default {
  name: "MaterialCenter",
  components: {YJVideo, VideoPage, AppHeader, AppBox, AppPagination, MaterialUploadModal},
  data() {
    return {
      materialInfo: null,
      materialType: "image",
      keyword: "",
      curTab: 1,
      page: 1,
      size: 15,
      total: 1,
      hasPagination: true,
      loading: false,
      dataSource: [],
      currentTenantId: Number(localStorage.getItem("tenantId"))
    };
  },
  computed: {
    sortPage() {
      return sortPage
    },
    ...mapState("user", ["permissionCode"]),
    pagination() {
      if (
          this.dataSource &&
          this.dataSource.length < 1 &&
          this.page !== 1 &&
          this.page * this.size > this.total
      ) {
        return {
          currentPage: this.page,
          pageSize: this.size,
          total: this.total + 1,
        };
      } else {
        return {
          currentPage: this.page || 1,
          pageSize: this.size || 10,
          total: this.total || 0,
        };
      }
    },
  },
  created() {
    this.getData();
  },
  methods: {
    ...mapMutations("courseCenter", ["setData"]),
    ...mapActions("courseCenter", [
      "searchMaterialResource",
      "saveMaterialResource",
      "deleteMaterialResource",
      "searchDisease",
      "saveDisease",
      "deleteDisease",
    ]),
    selectTag(type) {
      this.dataSource = [];
      this.curTab = type;
      this.getData();
    },
    pageChange(item) {
      this.page = item.page;

      console.log(item);
      this.getData();
    },
    async getData() {
      let res = {};
      if (this.curTab === 5) {
        res = await this.searchDisease({
          keyword: this.keyword,
          page: this.page,
          size: this.size,
          type: 2,
        });
      } else if (this.curTab === 4) {
        res = await this.searchDisease({
          keyword: this.keyword,
          page: this.page,
          size: this.size,
          type: 1,
        });
      } else {
        res = await this.searchMaterialResource({
          keyword: this.keyword,
          page: this.page,
          size: this.size,
          type: this.curTab,
        });
      }
      this.total = res.data.total;
      // 最多保留500页
      if (this.total > 500 * this.size) {
        this.total = 500 * this.size;
      }
      this.dataSource = res.data.data;
    },
    search() {
      this.page = 1;
      this.getData();
    },
    handleAdd() {
      this.materialInfo = null;
      if (this.curTab === 1) {
        this.materialType = "image";
      } else if (this.curTab === 2) {
        this.materialType = "audio";
      } else if (this.curTab === 3) {
        this.materialType = "video";
      } else if (this.curTab === 4) {
        this.materialType = "text";
      } else if (this.curTab === 5) {
        this.materialType = "text2";
      }
      this.setData({key: "materialUploadVisible", value: true});
    },
    refreshMaterialList() {
      this.getData();
    },
    handleEdit(item) {
      console.log(item)
      this.materialInfo = item;
      if (this.curTab === 1) {
        this.materialType = "image";
      } else if (this.curTab === 2) {
        this.materialType = "audio";
      } else if (this.curTab === 3) {
        this.materialType = "video";
      } else if (this.curTab === 4) {
        this.materialType = "text";
      } else if (this.curTab === 5) {
        this.materialType = "text2";
      }
      this.setData({key: "materialUploadVisible", value: true});
    },
    handleDelete(item) {
      console.log(item);
      this.$confirm("确定要删除此条内容吗？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
          .then(async () => {
            if (this.curTab === 4 || this.curTab === 5) {
              await this.deleteDisease({
                id: item.id,
                enable: false,
              });
            } else {
              await this.deleteMaterialResource({
                id: item.id,
                enable: false,
              });
            }


            this.$message({
              type: "success",
              message: "删除成功",
            });
            this.getData();
          })
          .catch(() => {
          });
    },
  },
};
</script>

<style lang="scss">
.MaterialCenter {
  .appBox {
    height: calc(100vh - 155px);
  }
}

.tabSelect {
  background-color: #10689c;
  color: white;
}

.tabUnSelect {
}

.materialContent {
  margin-top: 20px;
  height: calc(100vh - 300px);
  width: 100%;
  background-color: #ddd;
  float: left;

  .materialCard {
    float: left;
    width: 17.6%;
    height: calc(30vh - 100px);
    overflow: hidden;
    margin-left: 2%;
    margin-top: calc(2.5vh);
    //display: flex;
    justify-content: center;
    position: relative;

    .materialCardImage {
      background-color: white;
      width: 100%;
      height: 100%;
      justify-content: center;
      align-items: center;
      display: flex;

      .el-image__inner {
        width: auto;
        height: auto;
        max-width: 100%;
        max-height: 100%;
      }
    }

    .materialCardAudio {
      background-color: white;
      width: 100%;
      height: 100%;
    }

    .materialCardVideo {
      background-color: white;
      width: 100%;
      height: 100%;
    }

    .materialCardText {
      background-color: white;
      width: 100%;
      height: 100%;
      padding: 10px;
      position: relative;

      .materialCardTextTitle {
        font-size: 14px;
        line-height: 20px;
      }

      .materialCardTextContent {
        padding-top: 4px;
        font-size: 12px;
        padding-bottom: 10px;
        height: 90%;
        overflow-y: scroll;
        color: #999;
        line-height: 16px;
      }

      .materialCardTextContent::-webkit-scrollbar {
        width: 0;
      }
    }
  }
}

.pagenation {
  text-align: center;
  clear: both;
  margin-top: 10px;
  display: flex;
  justify-content: center;
}

.findInput {
  width: 200px;
  float: right;
}

.findButton {
  float: right;
  margin-left: 0px;
}

.addButton {
  float: right;
}

.cardOpRow {
  position: absolute;
  background: rgba(0, 0, 0, 0.2);
  right: 10px;
  top: 10px;
}

.deleteBtn {
  width: 28px;
  height: 28px;
  border: solid 1px white;
  text-align: center;
  color: white;
  cursor: pointer;
  padding: 4px;
}

.editBtn {
  width: 28px;
  height: 28px;
  line-height: 24px;
  border: solid 1px white;
  text-align: center;
  color: white;
  cursor: pointer;
}

</style>
